var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDroplets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2984,
    y1: 71.3947,
    x2: 28.1419,
    y2: 73.1078,
    gradientTransform: "matrix(16 0 0 -16 -370.9449 1204.3622)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#0056E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E5B8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.8,36c-3.6-5.4-7.6-10.9-9.3-15c-0.3-0.6-0.9-1.1-1.6-1c-0.7,0-1.3,0.4-1.5,1c-1.7,4.1-5.6,9.5-9.3,15 c-3.6,5.4-7,10.9-7,16.2C47.1,62,55.2,70,65,70c9.8,0,17.9-8,17.9-17.8C82.9,46.9,79.5,41.5,75.8,36L75.8,36z M77.5,50.4 c0,6.9-5.6,12.4-12.5,12.4c-0.9,0-1.7-0.7-1.7-1.6c0-0.9,0.7-1.7,1.6-1.7H65c5.1,0,9.1-4.1,9.1-9.1c0-0.9,0.7-1.7,1.6-1.7v0 C76.7,48.7,77.4,49.4,77.5,50.4L77.5,50.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplets);
export default __webpack_public_path__ + "static/media/Droplets.70d22db8225bc52a83576cf969fa4f8d.svg";
export { ForwardRef as ReactComponent };